var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071L8.65685 19.0711C9.04738 19.4616 9.68054 19.4616 10.0711 19.0711C10.4616 18.6805 10.4616 18.0474 10.0711 17.6569L4.41421 12L10.0711 6.34315C10.4616 5.95262 10.4616 5.31946 10.0711 4.92893C9.68054 4.53841 9.04738 4.53841 8.65685 4.92893L2.29289 11.2929ZM17 11L3 11V13L17 13V11Z",
    fill: "currentColor",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22L20.5 2",
    stroke: "currentColor",
    strokeOpacity: 0.65,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.68f69b00493b5b8b22eac7cb504c7253.svg";
export { ForwardRef as ReactComponent };